import { render } from "./PagamentoPixSucesso.vue?vue&type=template&id=ee8b01ec"
import script from "./PagamentoPixSucesso.vue?vue&type=script&lang=js"
export * from "./PagamentoPixSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__